import React from "react";

const CustomerServiceNotification = (
    <div>
        <h1>Title placeholder</h1>
        <p>Placeholder</p>
    </div>
)


export default CustomerServiceNotification;
